import { useRef, useEffect, useState } from "react";

export default function Petrinet({ petrinet, setPetrinet , zoom, setZoom, offsetPetrinet, setOffsetPetrinet}) {
  const containerRef = useRef(null);
  let draggingNode = null;
  let dragStartPos = { x: 0, y: 0 };

  useEffect(() => {
    updatePetrinetOffset(containerRef.current, petrinet, zoom, offsetPetrinet, setOffsetPetrinet);
  }, [petrinet]);


  if (!petrinet) return <p></p>;

    const handleZoomIn = () => {
        // change offset beforehand
        updatePetrinetOffset(containerRef.current, petrinet, zoom*1.2, offsetPetrinet, setOffsetPetrinet);
        setZoom((z) => z * 1.2);
    }
    const handleZoomOut = () => {
        // change offset beforehand
        updatePetrinetOffset(containerRef.current, petrinet, zoom/1.2, offsetPetrinet, setOffsetPetrinet);
        setZoom((z) => z / 1.2);
    }


      const handleMouseDown = (e, node) => {
        // Record the node being dragged and the initial mouse position
        draggingNode = node;
        dragStartPos = { x: e.clientX, y: e.clientY };

          document.addEventListener("mousemove", handleMouseMove);
          document.addEventListener("mouseup", handleMouseUp);
      };

        const handleMouseMove = (e) => {
        return; // remove all mouse move effects
          if (!draggingNode) return;

          const dx = e.clientX - dragStartPos.x;
          const dy = e.clientY - dragStartPos.y;

          // Update the node's position based on mouse movement
          const updatedNode = { ...draggingNode, x: draggingNode.x + dx/zoom, y: draggingNode.y + dy/zoom };

          // Update the state of the dragged node
          draggingNode = updatedNode;

          // Update the node's position in the `petrinet`
          let updatedNodes = petrinet.nodes.map(n => n.id === updatedNode.id ? updatedNode : n);
          const shiftX = Math.max(0, (offsetPetrinet.x-e.clientX)/zoom);
          const shiftY = Math.max(0, petrinet.height/2+(offsetPetrinet.y-e.clientY)/zoom);
          if (shiftY>0 | shiftX>0){
            updatedNodes = updatedNodes.map(n => ({
              ...n,           // Copy over the other properties of the node
              x: n.x + shiftX, // Update the x position
              y: n.y + shiftY  // Update the y position
            }));
          }
          const newHeight = Math.max(petrinet.height, (e.clientY-offsetPetrinet.y)/zoom, petrinet.height+shiftY);
          const newWidth = Math.max(petrinet.width, (e.clientX-offsetPetrinet.x)/zoom, petrinet.width+shiftX);

          setPetrinet({ ...petrinet, nodes: updatedNodes , width:newWidth, height:newHeight});

          // Update the drag start position
          dragStartPos = { x: e.clientX, y: e.clientY };
        };

        const handleMouseUp = (e) => {
          // Stop dragging
              document.removeEventListener("mousemove", handleMouseMove);
                document.removeEventListener("mouseup", handleMouseUp);
          draggingNode = null;
        };


    const Annotation = ({ ann, x, y }) => {
      const textRef = useRef(null);
      const [textWidth, setTextWidth] = useState(0);
      const rectHeight = 9;

      useEffect(() => {
        if (textRef.current) {
          const bbox = textRef.current.getBBox();
          setTextWidth(bbox.width);
        }
      }, []);

      return (
        <g>
          {/* Background rectangle */}
          <rect
            x={x - textWidth / 2}
            y={y - rectHeight + 2}
            width={textWidth}
            height={rectHeight}
            fill="white"
            rx={2}
          />
          {/* Text */}
          <text
            ref={textRef}
            x={x}
            y={y}
            fill="black"
            textAnchor="middle"
            fontSize="11"
          >
            {ann}
          </text>
        </g>
      );
    };

    return (
    <div>
    <div
          ref={containerRef}
      style={{
        width: "100%",
        height: "97vh", // or any fixed height
        overflow: "scroll",    // allows both vertical & horizontal scroll
        border: "1px solid #ccc",
      }}
      >
      <svg
        width={petrinet.width*zoom + "px"}
        height={petrinet.height*zoom + "px"}
        viewBox={`-10 -10 ${petrinet.width+20} ${petrinet.height+20}`}
            style={{
                      display: "block",
                      transform: `translate(${offsetPetrinet.x}px, ${offsetPetrinet.y}px)`,
                    }}
      >
        {/* Draw arcs */}
        {petrinet.arcs.map((arc, i) => {
          const source = petrinet.nodes.find((n) => n.id === arc.sourceId);
          const target = petrinet.nodes.find((n) => n.id === arc.targetId);
          if (!source || !target) return null;

          // update target coordinates along the angle, to include a small gap (so that arrow triangle is not hidden by node shape)
          let gap = 30 * 21.5/40;
          const x1 = source.x;
          const y1 = source.y;
          let x2 = target.x;
          let y2 = target.y;

        let throughX = x1;
        let throughY = y1;
        if (arc.throughX!=null){
           throughX = arc.throughX;
           throughY = arc.throughY;
        }
        const angle = Math.atan2(y2-throughY,x2-throughX); // angle between x-axis and line from source to target
                  x2 = x2-gap*Math.cos(angle);
                  y2 = y2-gap*Math.sin(angle);

          return (
              <polyline
                key={i}
                points={`${x1},${y1} ${throughX},${throughY} ${x2},${y2}`}
                fill="none"
                stroke="black"
                markerEnd="url(#arrowhead)"
              />
          );
        })}

        {/* Draw nodes */}
        {petrinet.nodes.map((node, i) => (
          <g key={i}
               onMouseDown={(e) => handleMouseDown(e, node)}
            >
            {node.type === "place" ? (
              <circle
                cx={node.x}
                cy={node.y}
                r={15}
                fill="white"
                stroke="black"
              />
            ) : (
              <rect
                x={node.x - 15}
                y={node.y - 15}
                width={30}
                height={30}
                fill="white"
                stroke="black"
              />
            )}
            <text x={node.x} y={node.y} textAnchor="middle" dominantBaseline="middle" fontSize="7.5">
                {node.type !== "place" &&
                    node.id.split(/(?=[A-Z])/).map((part, i, arr) => (
                      <tspan
                        key={i}
                        x={node.x}
                        dy={i === 0 ? `-${((arr.length - 1) * 1.2) / 2}em` : "1.2em"}
                      >
                        {part + (i === arr.length - 1 ? "" : "-")}
                      </tspan>
                    ))
                  }
              </text>

            {/* Annotations below the node */}
                  {node.annotations &&
                    node.annotations.map((ann, i) => {
                         const x = node.x;
                           const y = node.y + 30 / 2 + 15 + i * 13;
                           return <Annotation key={i} ann={ann} x={x} y={y} />;
                    }
                    )}

                  {/* Label to the left */}
                  {node.guard && node.guard!="" && (
                    <text
                      x={node.x-30 / 2 - 10} // to the left of node
                      y={node.y}                  // vertically centered
                      textAnchor="end"
                      dominantBaseline="middle"
                      fontSize="11"
                    >
                      {node.guard}
                    </text>
                  )}
          </g>
        ))}

        {/* Define arrowhead marker */}
        <defs>
          <marker
            id="arrowhead"
            markerWidth="10"
            markerHeight="7"
            refX="10"
            refY="3.5"
            orient="auto"
          >
            <polygon points="0 0, 10 3.5, 0 7" fill="black" />
          </marker>
        </defs>
      </svg>
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            left: "10px",
            background: "rgba(255,255,255,0.8)",
            padding: "5px",
            borderRadius: "5px",
            zIndex: 10,
            display: "flex",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <button onClick={handleZoomIn}>+</button>
          <button onClick={handleZoomOut}>-</button>
        </div>

      </div>
      </div>
    );
  };





  export const updatePetrinetOffset = (container, petrinet, zoom, offsetPetrinet, setOffsetPetrinet)=>{

      if (!petrinet) return;

      if (!container){ // set off screen until ready to be fully rendered
              setOffsetPetrinet({
                x: window.innerWidth,
                y: window.innerHeight,
              });
        return;
      }

           const containerWidth = container.clientWidth;
           const containerHeight = container.clientHeight;


      const svgWidth = petrinet.width * zoom;
      const svgHeight = petrinet.height * zoom;

      const newOffsetX = Math.max((containerWidth - svgWidth) / 2, 0)
      const newOffsetY = Math.max((containerHeight - svgHeight) / 2, 0)

      if (offsetPetrinet.x==null || newOffsetX!=offsetPetrinet.x || newOffsetY!=offsetPetrinet.y){
      setOffsetPetrinet({
        x: newOffsetX,
        y: newOffsetY,
      });
      }
  }